import PropTypes from 'prop-types'
import {
  Carousel, Container, Row,
  Col, Card,
} from 'react-bootstrap'
import { Button, Breadcrumb } from 'antd'
import {
  PlayCircleTwoTone, GlobalOutlined, ShoppingOutlined,
  PhoneOutlined, ReadOutlined, CalendarOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons'
import { InfoCard, MitraCard, ArticleCard } from 'components/elements'

const FollowSiplah = () => (
  <div className="h-100">

    {/*= ========= breadcrumb section ========== */}
    <section className="py-4 bg-pearl-blue">
      <Container className="section-header">
        <Breadcrumb>
          <Breadcrumb.Item>
            <a href="/">Home</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Ikuti SIPLah</Breadcrumb.Item>
        </Breadcrumb>
      </Container>
    </section>

    {/*= ========= info section ========== */}
    <section className="py-5">
      <Container>
        <div className="text-center" />
        <Row>
          <Col xs={12} lg={3} className="mb-3 mb-lg-0">
            <InfoCard
              icon={<InfoCircleOutlined />}
              title="Pengumuman SIPLah"
              shortDescription="Untuk mengetahui Pengumuman terbaru SIPLah"
            />
          </Col>
          <Col xs={12} lg={3} className="mb-3 mb-lg-0">
            <InfoCard
              icon={<CalendarOutlined />}
              title="Agenda SIPLah"
              shortDescription="Berisi agenda terbaru SIPLah"
            />
          </Col>
          <Col xs={12} lg={3} className="mb-3 mb-lg-0">
            <InfoCard
              icon={<ReadOutlined />}
              title="Liputan SIPLah"
              shortDescription="Berisi tentang liputan terbaru SIPLah"
            />
          </Col>
          <Col xs={12} lg={3} className="mb-3 mb-lg-0">
            <InfoCard
              icon={<GlobalOutlined />}
              title="Social Media SIPLah"
              shortDescription="Subscribe dan ikuti media sosial SIPLah untuk mendapatkan informasi terkini."
            />
          </Col>
        </Row>
      </Container>
    </section>

    {/*= ========= cari tahu section ========== */}
    <section className="py-5 bg-pearl-blue">
      <Container className="section-header">
        <div className="title-wrapper text-center mb-5">
          <h2><a href="https://siplah.kemendikdasmen.go.id/index.php/ikuti">PENGUMUMAN SIPLAH</a></h2>
          <h3>
            Cari tahu pengumuman
            <span>SIPLah</span>
          </h3>
          <p>Pengumuman</p>
        </div>
        <Row>
          <Col lg={12}>
            <ul className="pl-0 pl-lg-3 news-wrapper">
              <li className="d-flex">
                <InfoCircleOutlined />
                <div className="ml-2 text-justify">
                  <p>08 Jun 2021</p>
                  <h5>
                    <a href="https://siplah.kemendikdasmen.go.id/index.php/pengumuman/entry/pengumuman-pelaksanaan-uat">PENGUMUMAN PELAKSANAAN UAT</a>
                  </h5>
                  <p>
                    Menindaklanjuti kegiatan Pemilihan Calon Mitra SIPLah Periode 2021-2023, dimana akan dilakukan proses UAT (User Aceptensse Test), Panitia Pemilihan Calon Mitra SIPLah telah mengirimkan Surat Informasi Pelaksanaan UAT pada masing-masing Calon Mitra SIPLah yang telah lolos sampai tahap pengembangan sistem. Seluruh Calon Mitra SIPLah diminta untuk mengecek email. Sebagai catatan dokumen yang harus dilengkapi berupa formulir isian self test, Surat Balasan dikirim ke email sds.siplah[at]kemendikdasmen.go.id dan ke kantor Pusdatin Jl. RE. Martadinata KM 15.5, Cipayung, Ciputat dokumen tersebut diterima selambat-lambatnya tanggal 14 Juni 2021.
                    Bagi Mitra yang belum mendapatkan email tersebut silahkan menghubungi Panitia melalui email sds.siplah[at]kemendikdasmen.go.id Terima Kasih
                    <a href="https://siplah.kemendikdasmen.go.id/index.php/pengumuman/entry/pengumuman-pelaksanaan-uat">[Baca Selengkapnya]</a>
                  </p>
                </div>
              </li>
            </ul>
          </Col>
          <Col lg={12}>
            <ul className="pl-0 pl-lg-3 news-wrapper">
              <li className="d-flex">
                <InfoCircleOutlined />
                <div className="ml-2 text-justify">
                  <p>08 Jun 2021</p>
                  <h5>
                    <a href="https://siplah.kemendikdasmen.go.id/index.php/pengumuman/entry/pengumuman-pelaksanaan-uat">PENGUMUMAN PELAKSANAAN UAT</a>
                  </h5>
                  <p>
                    Menindaklanjuti kegiatan Pemilihan Calon Mitra SIPLah Periode 2021-2023, dimana akan dilakukan proses UAT (User Aceptensse Test), Panitia Pemilihan Calon Mitra SIPLah telah mengirimkan Surat Informasi Pelaksanaan UAT pada masing-masing Calon Mitra SIPLah yang telah lolos sampai tahap pengembangan sistem. Seluruh Calon Mitra SIPLah diminta untuk mengecek email. Sebagai catatan dokumen yang harus dilengkapi berupa formulir isian self test, Surat Balasan dikirim ke email sds.siplah[at]kemendikdasmen.go.id dan ke kantor Pusdatin Jl. RE. Martadinata KM 15.5, Cipayung, Ciputat dokumen tersebut diterima selambat-lambatnya tanggal 14 Juni 2021.
                    Bagi Mitra yang belum mendapatkan email tersebut silahkan menghubungi Panitia melalui email sds.siplah[at]kemendikdasmen.go.id Terima Kasih
                    <a href="https://siplah.kemendikdasmen.go.id/index.php/pengumuman/entry/pengumuman-pelaksanaan-uat">[Baca Selengkapnya]</a>
                  </p>
                </div>
              </li>
            </ul>
          </Col>
          <Col lg={12}>
            <ul className="pl-0 pl-lg-3 news-wrapper">
              <li className="d-flex">
                <InfoCircleOutlined />
                <div className="ml-2 text-justify">
                  <p>08 Jun 2021</p>
                  <h5>
                    <a href="https://siplah.kemendikdasmen.go.id/index.php/pengumuman/entry/pengumuman-pelaksanaan-uat">PENGUMUMAN PELAKSANAAN UAT</a>
                  </h5>
                  <p>
                    Menindaklanjuti kegiatan Pemilihan Calon Mitra SIPLah Periode 2021-2023, dimana akan dilakukan proses UAT (User Aceptensse Test), Panitia Pemilihan Calon Mitra SIPLah telah mengirimkan Surat Informasi Pelaksanaan UAT pada masing-masing Calon Mitra SIPLah yang telah lolos sampai tahap pengembangan sistem. Seluruh Calon Mitra SIPLah diminta untuk mengecek email. Sebagai catatan dokumen yang harus dilengkapi berupa formulir isian self test, Surat Balasan dikirim ke email sds.siplah[at]kemendikdasmen.go.id dan ke kantor Pusdatin Jl. RE. Martadinata KM 15.5, Cipayung, Ciputat dokumen tersebut diterima selambat-lambatnya tanggal 14 Juni 2021.
                    Bagi Mitra yang belum mendapatkan email tersebut silahkan menghubungi Panitia melalui email sds.siplah[at]kemendikdasmen.go.id Terima Kasih
                    <a href="https://siplah.kemendikdasmen.go.id/index.php/pengumuman/entry/pengumuman-pelaksanaan-uat">[Baca Selengkapnya]</a>
                  </p>
                </div>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </section>

    {/*= ========= agenda section ========== */}
    <section className="py-5">
      <Container className="section-header">
        <div className="title-wrapper text-center mb-5">
          <h2><a href="https://siplah.kemendikdasmen.go.id/index.php/ikuti">AGENDA SIPLAH</a></h2>
          <h3>
            Cari tahu Agenda
            <span>SIPLah</span>
          </h3>
        </div>
        <Row>
          <Col lg={12}>
            <ul className="pl-0 pl-lg-3 news-wrapper">
              <li className="d-flex">
                <InfoCircleOutlined />
                <div className="ml-2 text-justify">
                  <p>23 Feb 2021 | PENGUMUMAN</p>
                  <h5>Pemilihan Mitra Sistem Pasar Daring SIPLah untuk periode Tahun 2021-2023</h5>
                  <p>Kementerian Pendidikan dan Kebudayaan (Kemendikbud) telah memanfaatkan Sistem Informasi Pengadaan Sekolah (SIPLah) yaitu sistem elektronik yang dapat digunakan oleh Satuan Pendidikan untuk melaksanakan proses Pengadaan Barang dan Jasa (PBJ) secara daring, dengan menggunakan sumber dana bantuan pemerintah.</p>
                  <p>Sejak tahun 2019 sampai dengan saat ini, Kementerian Pendidikan dan Kebudayaan telah melakukan Kerjasama dengan 6 (enam) Mitra Pasar Daring SIPLah yaitu PT. Eureka Bookhouse (Eureka), PT. Global Digital Niaga (Blibli.com), PT. Industri Telekomunikasi Indonesia Persero (SIPlah.id/INTI), PT. Ladang Karya Husada (Ladang), PT. Metraplasa (Blanja.com), dan PT. Pesona Edukasi (PesonaEdu).</p>
                  <p>SIPLah dirancang untuk memanfaatkan Sistem Pasar Daring (Online Marketplace) yang dioperasikan oleh pihak ketiga. Sistem pasar daring yang dapat dikategorikan sebagai SIPLah harus memiliki fitur tertentu dan memenuhi kebutuhan Kementerian Pendidikan dan Kebudayaan sesuai dengan Peraturan Menteri Pendidikan dan Kebudayaan Nomor 14 Tahun 2020 tentang Pedoman Pengadaan Barang/Jasa oleh Satuan Pendidikan.</p>
                  <p>Berdasarkan Kontrak Payung dan Surat Perjanjian Kerjasama yang telah dilakukan antara Kemendikbud dengan para Mitra Pasar Daring pada tahun 2019, Tanggal 31 Juli 2021 adalah batas akhir Kontrak Payung dan Perjanjian Kerjasama. Untuk itu, Kemendikbud akan melakukan kembali proses pemilihan Mitra Sistem Pasar Daring untuk periode Tahun 2021-2023. Pemilihan Mitra Sistem Pasar Daring tersebut dapat diikuti oleh seluruh Pasar Daring yang ada di Indonesia atau Calon Mitra Pasar Daring baru yang berminat.</p>
                  <p>Calon Mitra Pasar Daring SIPLah dapat mengajukan/mengirimkan surat peminatan sebagai Mitra Pasar Daring SIPLah melalui email sds.siplah@kemendikdasmen.go.id dengan mencantumkan subject email “Peminatan Terhadap Calon Mitra Pasar Daring SIPLah” dan Narahubung yang dapat dihubungi oleh Pihak Kemendikbud paling lambat pada hari Senin, tanggal 8 Maret 2021.</p>
                  <p>Selain mengirimkan surat peminatan tersebut melalui email, surat peminatan dapat dikirimkan langsung kepada Kepala Pusat Data dan Teknologi Informasi dan dikirimkan ke Pusat Data dan Teknologi Informasi (Pusdatin Kemendikbud) Jalan RE Martadinata KM. 15.5 Cipayung, Ciputat, Tangerang Selatan, Banten 15411 dengan mencantumkan dipojok kiri atas amplop “Peminatan Terhadap Calon Mitra Pasar Daring SIPLah”.</p>
                  <p>Untuk keterangan lebih lanjut dapat mengunjungi website siplah.kemendikdasmen.go.id.</p>
                </div>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </section>

    {/*= ========= article liputan section ========== */}
    <section className="py-5 bg-pearl-blue">
      <Container className="section-header">
        <div className="title-wrapper text-center mb-5">
          <h2>LIPUTAN SIPLAH</h2>
          <h3>
            Cari tahu liputan
            <span>SIPLah</span>
          </h3>
          <p>Liputan Siplah</p>
        </div>
        <Row>
          <Col lg={12} className="mb-5">
            <ArticleCard
              thumbnailImg="./assets/article-liputan-1.jpeg"
              title="Bimbingan Teknis Peningkatan Tata Kelola Pengadaan Barang dan Jasa Di Satuan Pendidikan Melalui SIPLah Untuk Satuan Pendidikan dan UMKM di Yogyakarta"
              url="https://siplah.kemendikdasmen.go.id/index.php/liputan/entry/bimbingan-teknis-peningkatan-tata-kelola-pengadaan-barang-dan-jasa-di-satuan-pendidikan-melalui-siplah-untuk-satuan-pendidikan-dan-umkm-di-yogyakarta"
              date="12 Dec 2020"
              shortDescription={(
                <p>
                  Yogyakarta, Kemendikbud. Biro Umum dan Pengadaan Barang dan Jasa, Kementerian Pendidikan dan Kebudayaan (Kemendikbud) melanjutkan safari Bimbingan Teknis Peningkatan Tata Kelola Pengadaan Barang dan Jasa Di Satuan Pendidikan di beberapa kota besar di Indonesia,
                  kali ini giliran Kota Yogyakarta. Acara ini diselenggarakan dalam rangka untuk melakukan fasilitasi dan edukasi SIPLah kepada satuan Pendidikan dan usaha mikro kecil dan menengah (UMKM), dengan menggandeng Kementerian Koperasi dan UKM, Dinas Pendidikan Provinsi DIY
                  {' '}
                </p>
                )}
            />
          </Col>
          <Col lg={12} className="mb-5">
            <ArticleCard
              thumbnailImg="./assets/article-liputan-2.jpeg"
              title="Bimbingan Teknis Peningkatan Tata Kelola Pengadaan Barang dan Jasa Di Satuan Pendidikan Melalui SIPLah Untuk Satuan Pendidikan dan UMKM di Surabaya, Jawa Timur"
              url="https://siplah.kemendikdasmen.go.id/index.php/liputan/entry/bimbingan-teknis-peningkatan-tata-kelola-pengadaan-barang-dan-jasa-di-satuan-pendidikan-melalui-siplah-untuk-satuan-pendidikan-dan-umkm-di-surabaya-jawa-timur"
              date="9 Dec 2020"
              shortDescription={(
                <p>
                  Surabaya, Kemendikbud. Dalam rangka untuk melakukan fasilitasi dan edukasi SIPLah kepada satuan Pendidikan dan usaha mikro kecil dan menengah (UMKM), Biro Umum dan Pengadaan Barang dan Jasa, Kementerian Pendidikan dan Kebudayaan (Kemendikbud) mengadakan Bimbingan
                  Teknis Peningkatan Tata Kelola Pengadaan Barang dan Jasa Di Satuan Pendidikan di beberapa kota besar di Indonesia, kali ini giliran Kota Surabaya Jawa Timur.
                  {' '}
                </p>
                )}
            />
          </Col>
        </Row>
      </Container>
    </section>
  </div>
)

FollowSiplah.propTypes = {

}

export default FollowSiplah
